<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>Dedicated to Grenville Dechastaigne Vernon who died at 10 years old, his father, a Harvard graduate. The Vernon family was the founder of the US Navy during the American Revolution (see Newport this week and also Samuel Brown Vernon, Treasurer of Rhode Island).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1e93cd93